import React from "react";
import { Form, Input, Button, Card } from "antd";
import { PlusOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { defaultAboutUs } from "./defaults";
import type { SectionMeta } from "./types";

export const meta: SectionMeta = {
  key: "about_us",
  label: "About Us",
  icon: <InfoCircleOutlined />,
  color: "#3b82f6",
  desc: "About section title, content and image",
};

export const defaultData = defaultAboutUs;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  const item = data[0];
  return (
    <div className="space-y-1 text-sm">
      <div className="font-semibold text-gray-800 truncate">
        {item.about_title}
      </div>
      <div className="text-gray-500 text-xs line-clamp-2">
        {item.about_content}
      </div>
      {item.about_image && (
        <div className="text-xs text-blue-500">Image: {item.about_image}</div>
      )}
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.List name="about_us">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <Card
            key={field.key}
            className="!mb-3"
            size="small"
            type="inner"
            extra={
              <Button
                type="text"
                danger
                size="small"
                onClick={() => remove(field.name)}
                icon={<DeleteOutlined />}
              />
            }
          >
            <div className="grid grid-cols-2 gap-3">
              <Form.Item
                {...field}
                name={[field.name, "about_title"]}
                label="About Title"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. About Us" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "about_image"]}
                label="About Image"
                className="!mb-0"
              >
                <Input placeholder="image filename" />
              </Form.Item>
            </div>
            <Form.Item
              {...field}
              name={[field.name, "about_content"]}
              label="About Content"
              rules={[{ required: true, message: "Required" }]}
            >
              <Input.TextArea rows={4} placeholder="Write about your company..." />
            </Form.Item>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          onClick={() => add(defaultAboutUs[0])}
          icon={<PlusOutlined />}
          className="!mb-1"
        >
          Add About Section
        </Button>
      </>
    )}
  </Form.List>
);
